import { Col, Divider, Row, Space } from "antd";
import { Form, Formik } from "formik";

import { Button } from "components/elements";
import SubInfoSwitch from "components/elements/InfoSwitch/SubInfoSwitch";
import ColumnSwitch from "components/elements/InfoSwitch/columnSwitch";
import { Input, Select } from "components/form";
import { MainLayout } from "components/layouts";

import styles from "../styles/Attendance.module.css";

const AttendanceEdit = ({
  initialValues = {},
  onBack = () => {},
  onSubmitCreate = () => {},
  goToCancle = () => {},
  setMenu = () => {},
}) => {
  return (
    <MainLayout
      title="Edit Leave Type"
      breadcrumb={[
        { title: "Home", link: "/" },
        { title: "Configuration", link: "/" },
        { title: "Attendance Setting", link: "/" },
        { title: "edit" },
      ]}
    >
      <Formik initialValues={initialValues} onSubmit={onSubmitCreate}>
        {({ values = {}, setTouched = () => {} }) => {
          return (
            <Form>
              <Space
                className={styles.subContainer}
                size={24}
                direction="vertical"
              >
                <div className="card">
                  <Row justify="space-between">
                    <b className={styles.infoTopic}>Edit</b>
                  </Row>
                  <Divider />
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <Input
                        name="name_th"
                        label="Leave Type Name (TH) *"
                        placeholder="Leave Type Name (TH) *"
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="name_en"
                        label="Leave Type Name (EN) *"
                        placeholder="Leave Type Name (EN) *"
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="category"
                        label="Leave Category *"
                        placeholder="Leave Category *"
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="description"
                        label="Description *"
                        placeholder="Description *"
                        size="large"
                      />
                    </Col>
                  </Row>

                  <Row justify="space-between" style={{ paddingTop: "24px" }}>
                    <b className={styles.infoTopic}>Leave Condition</b>
                  </Row>
                  <Divider />
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <Select
                        name="minimum_leave"
                        label="Minimum leave required *"
                        placeholder="Minimum leave required *"
                        size="large"
                        options={[
                          { label: "60 Minutes", value: "60" },
                          { label: "55 Minutes", value: "55" },
                          { label: "50 Minutes", value: "50" },
                          { label: "45 Minutes", value: "45" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="document_limit"
                        label="Document limit per day *"
                        placeholder="Document limit per day *"
                        size="large"
                        options={[
                          { label: "1 document", value: "1" },
                          { label: "2 document", value: "2" },
                          { label: "3 document", value: "3" },
                          { label: "4 Mdocument", value: "4" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="request_condition"
                        label="Request Condition *"
                        placeholder="Request Condition *"
                        size="large"
                        options={[]}
                      />
                    </Col>
                    <Col span={12}>
                      <ColumnSwitch label="Permanent employees only" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Half-day Leave" />
                    </Col>
                    <Col span={12}></Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Consecutive Leave Limit" />
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                  <Row justify="space-between" style={{ paddingTop: "24px" }}>
                    <b className={styles.infoTopic}>Leave Request</b>
                  </Row>
                  <Divider />
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <SubInfoSwitch label="Permanent employees only" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Attachment required" />
                    </Col>

                    <Col span={12}>
                      <SubInfoSwitch label="Allow Once" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Count holidays as leave days" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Extra Allowance" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Diligence Allowance" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Leave Without Pay" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Available only in the birth month" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Available only in the birth month" />
                    </Col>
                    <Col span={12}>
                      <SubInfoSwitch label="Include probation period" />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="gender"
                        label="Gender  *"
                        placeholder="Gender *"
                        size="large"
                        options={[
                          { label: "All Gender", value: "all_Gender" },
                          { label: "Male", value: "male" },
                          { label: "Female", value: "female" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="leave_Calculation *"
                        label="Leave Calculation *"
                        placeholder="Leave Calculation *"
                        size="large"
                        options={[]}
                      />
                    </Col>
                  </Row>

                  <Row justify="end" style={{ paddingTop: "24px" }}>
                    <Space size={24}>
                      <Button
                        type="default"
                        onClick={() => {
                          goToCancle();
                          setMenu("leave");
                        }}
                      >
                        CANCEL
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={onSubmitCreate}
                      >
                        SAVE
                      </Button>
                    </Space>
                  </Row>
                </div>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </MainLayout>
  );
};

export default AttendanceEdit;
